import React, { useState } from "react";
import { IconButton } from "@mui/material";
import Info from "@mui/icons-material/Info";

import { getTranslateByKey } from "@/main/services/utils";
import RenderTooltipMessage from "@/main/components/shared/renderTooltipMessage/renderTooltipMessage";

import ModalContacts from "./modalContacts";
import { IInfoProcurement } from "./accordionContacts/accordionContacts";
import { createPortal } from "react-dom";

interface IModalContactsWithIconProps {
	idScreen: string;
	guidCompany: string;
	infoProcurement: IInfoProcurement;
}
function ModalContactsWithIcon({ guidCompany, idScreen, infoProcurement }: IModalContactsWithIconProps) {
	const [showContactModal, setShowContactModal] = useState(false);

	function handleShowContactModal(e: React.MouseEvent<HTMLButtonElement>) {
		e.preventDefault();
		e.stopPropagation();
		setShowContactModal((prev) => !prev);
	}

	const generateId = (id: string) => `${idScreen}-${id}`;

	return (
		<>
			<RenderTooltipMessage tooltipMessage={getTranslateByKey("information.viewContacts")} placement="top">
				<span>
					<IconButton
						id={generateId("icon-open-contacts")}
						size="medium"
						color="primary"
						style={{ marginLeft: 5 }}
						onClick={handleShowContactModal}
					>
						<Info />
					</IconButton>
				</span>
			</RenderTooltipMessage>
			{createPortal(
				<ModalContacts
					open={showContactModal}
					infoProcurement={infoProcurement}
					guidCompany={guidCompany}
					closeModal={() => setShowContactModal(false)}
				/>,
				document.body,
			)}
		</>
	);
}

export default ModalContactsWithIcon;
